import { Person } from '../models/person';

export class User extends Person {

}



// WEBPACK FOOTER //
// ./src/models/user.ts